/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */
import React from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";

/**
 * Rate plan table.
 * @param data Data to render
 * @returns {Element} Element
 */
const RatePlanTable = ({data}) => {
  if (data !== undefined) {
    return (
      <TableContainer component={Paper} style={{ marginTop: '20px', padding: '20px' }}>
        <Typography variant="h5" align="center" gutterBottom>
          UDF Rate Plans
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '16px' }}>Rate Plan Code</TableCell>
              <TableCell align="center" style={{ fontWeight: 'bold', fontSize: '16px' }}>Reservations count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.udf.map((item, index) => (
              <TableRow key={index}>
                <TableCell align="center">{item.plan}</TableCell>
                <TableCell align="center">{item.count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};

export default RatePlanTable;
